import React from 'react';

import { Box, Flex } from '@rover/kibble/core';
import useLocationContext from '@rover/react-lib/src/context/useLocationContext';
import { useCurrentUser } from '@rover/rsdk/src/modules/Data/Core/CurrentUser';

import ContactButton from '../../../components/ContactButton';
import { useRevampCta } from '../../hooks/useRevampCta';
import { useRevampProfileContext } from '../../hooks/useRevampProfileContext';

import RevampCancellationPolicy from './RevampCancellationPolicy';
import RevampMobileCtaBarCommon from './RevampMobileCtaCommon';
import RevampMobileCtaPtBannerCommon from './RevampMobileCtaPtBannerCommon';
import { CTAProps } from './RevampServicesCta';
import { getSitterSlugFromWebUrl } from './utils';

type Props = {
  handleOpenSheet: () => void;
};

const RevampMobileCtaBarOwnerView = ({
  handleOpenSheet,
  priceTransparencyLevel,
  language,
  petCount,
  petType,
  bookingFeePercentage,
}: Props & CTAProps): JSX.Element => {
  const { contactUrl } = useRevampProfileContext();
  const { sitterData, selectedService, cancellationPolicy } = useRevampCta();
  const currentUser = useCurrentUser();
  const location = useLocationContext();

  const sitterSlug = getSitterSlugFromWebUrl(sitterData.webUrl);

  return (
    <>
      <Flex justifyContent="space-between" alignItems="center" pb="3x">
        <RevampMobileCtaBarCommon
          handleOpenSheet={handleOpenSheet}
          priceTransparencyLevel={priceTransparencyLevel}
          language={language}
          petCount={petCount}
          petType={petType}
        />
      </Flex>

      <RevampMobileCtaPtBannerCommon
        priceTransparencyLevel={priceTransparencyLevel}
        petCount={petCount}
        petType={petType}
        bookingFeePercentage={bookingFeePercentage}
      />

      <Box pb="3x">
        <ContactButton
          sitterInfo={sitterData}
          sitterSlug={sitterSlug}
          contactUrl={contactUrl}
          isLoggedIn={currentUser.isAuthenticated}
          location={location}
          pagePosition="sticky-footer"
          shouldShowRevampLayout
          webProps={{
            sx: {
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            },
          }}
        />
      </Box>

      <RevampCancellationPolicy
        cancellationPolicy={cancellationPolicy}
        serviceName={selectedService?.displayName}
        cancellationPolicyDesc={selectedService?.meta?.cancellationPolicyDesc}
      />
    </>
  );
};

export default RevampMobileCtaBarOwnerView;
